import { Resume } from '@/types/resume/v1'
import {
  Paragraph,
  SectionType,
  TextRun,
  HeadingLevel,
  ISectionOptions,
} from 'docx'

const references = ({ references }: Resume.Schema): ISectionOptions => {
  return {
    properties: {
      type: SectionType.CONTINUOUS,
    },
    children: [
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: 'References',
        heading: HeadingLevel.HEADING_2,
      }),
      ...references.reduce<Paragraph[]>((acc, referenceItem) => {
        return [...acc, ...createReferenceItem(referenceItem)]
      }, []),
    ],
  }
}

const createReferenceItem = (reference: Resume.Reference): Paragraph[] => {
  const item: Paragraph[] = []
  item.push(
    new Paragraph({
      text: '\n',
    })
  )
  item.push(
    new Paragraph({
      children: [
        new TextRun({
          text: reference.name,
          bold: true,
        }),
      ],
    })
  )
  item.push(
    new Paragraph({
      text: reference.reference,
    })
  )
  return item
}

export default references
